import { render } from "./allReviews.vue?vue&type=template&id=1dbd5fc5"
import script from "./allReviews.vue?vue&type=script&lang=js"
export * from "./allReviews.vue?vue&type=script&lang=js"

import "./allReviews.vue?vue&type=style&index=0&id=1dbd5fc5&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__